import { Injectable, inject } from '@angular/core';
import { ModelCardData } from '../components/model-card/model-card.component';
import { FormatService } from './format.service';
import { HelperService } from './helper.service';

/** Maps catalogue API model items to {@link ModelCardData} for consistent model cards across the app. */
@Injectable({ providedIn: 'root' })
export class ModelCardMapperService {
  private readonly formatService = inject(FormatService);
  private readonly helperService = inject(HelperService);

  mapApiItemToModelCard(item: any): ModelCardData {
    const id = item?.id || item?.['@id'] || '';
    const title = item?.label || item?.name || 'Untitled';
    const organization =
      item?.organizationName ||
      item?.provider ||
      item?.organisation ||
      item?.organization ||
      item?.provider_name ||
      item?.uploadedBy ||
      '';
    const rawDesc =
      item?.shortDescription ??
      item?.short_description ??
      item?.sortDescription ??
      item?.description ??
      '';
    const shortDescription =
      typeof rawDesc === 'string' && rawDesc.trim()
        ? rawDesc.length > 120
          ? `${rawDesc.trim().slice(0, 120)}…`
          : rawDesc.trim()
        : undefined;

    const apiTags: string[] = Array.isArray(item?.tags) ? [...item.tags] : [];

    let industry = '';
    if (item?.industry) {
      if (Array.isArray(item.industry)) {
        industry = item.industry
          .filter((value: unknown) => value !== null && value !== undefined && value !== '')
          .join(', ');
      } else if (typeof item.industry === 'string' && item.industry.trim() !== '') {
        industry = item.industry.trim();
      }
    }

    const modelType = item?.modelType || '';
    const language = item?.codeLanguage || item?.programmingLanguage || item?.language || '';
    const fileFormat = item?.fileFormat || item?.format || '';
    const date = this.formatService.formatDateForModelCard(
      item?.lastUpdated || item?.itemCreatedAt || item?.createdAt || new Date(),
    );
    const badge = this.helperService.extractAccessBadge(item);
    const badgeColor = this.helperService.getBadgeColorVariant(badge);
    const metricsData = item?.metrics || {};
    const metrics = {
      likes: metricsData.likes ?? item?.likeCount ?? item?.likes ?? item?.like_count ?? 0,
      downloads:
        metricsData.downloads ?? item?.downloadCount ?? item?.downloads ?? item?.download_count ?? 0,
      files: item?.fileCount || item?.files || item?.file_count || 0,
      views: metricsData.views ?? item?.viewCount ?? item?.views ?? item?.view_count ?? 0,
      dislikes: metricsData.dislikes ?? 0,
    };

    return {
      id,
      title,
      organization,
      shortDescription,
      industry,
      tags: apiTags.slice(0, 3),
      modelType,
      language,
      fileFormat: fileFormat || undefined,
      date,
      badge,
      badgeColor,
      link: `/model/${id}`,
      metrics,
    };
  }
}
